<template>
  <div class="rise">
    <div class="banner">
      <img src="@i/rise/banner.png" alt="" />
      <div class="btn-g">
        <!-- <b-button>添加官方微信号</b-button>
        <b-button pill>立即咨询</b-button> -->
      </div>
    </div>
    <div class="seven">
      <des :hasLine="false">
        <template slot="title"> “流量”难题 企业如何破局 </template>
        <template slot="des"> 深知行业难题，所以更需专业！ </template>
      </des>
      <img src="@i/rise/seven.png" alt="" />
    </div>
    <des :hasLine="false">
      <template slot="title">
        <span style="color: #323232">智晓慧热门产品</span>
      </template>
      <template slot="des"> 抖管家SaaS系统 助力企业私域用户量级增长 </template>
    </des>
    <div class="hot">
      <b-container class="bv-example-row">
        <b-row align-v="center">
          <b-col md="6" sm="6" xs="12">
            <div class="word">
              <div class="title">
                <img src="@i/rise/star.png" alt="" />
                <div>
                  <p class="title-heading">吸粉获客——AI外呼</p>
                  <p class="title-des">
                    站内配套AI外呼单日可触达用户10万+ 大大降低获客成本
                  </p>
                </div>
              </div>
              <div class="list-box">
                <div class="list">
                  <div class="list-title">
                    历史老客户<span style="color: #0073f8">激活</span>
                  </div>
                  <div class="list-subtitle">
                    批量导入历史客户通讯录，自定义话术，AI机器人自动拨通客户电话，
                    根据客户反馈自动分层客户价值。
                  </div>
                </div>
                <div class="list">
                  <div class="list-title">
                    价值客户<span style="color: #0073f8">主动</span>添加微信
                  </div>
                  <div class="list-subtitle">
                    通过价值客户分享，向高价值客户发送短信，引导客户主动添加微信。
                  </div>
                </div>
                <div class="list">
                  <div class="list-title">
                    价值客户<span style="color: #0073f8">自动</span>添加微信
                  </div>
                  <div class="list-subtitle">
                    通过客户价值分层，批量导入高价值客户通讯录，自定义微信添加话术，
                    微信机器人自动添加客户为好友。
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col md="6" sm="6" xs="12">
            <div class="mackbook">
              <img src="@i/rise/mackbook1.png" alt="" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="hot">
      <b-container class="bv-example-row">
        <b-row align-v="center">
          <b-col md="6" sm="6" xs="12">
            <div class="mackbook">
              <img src="@i/rise/mackbook2.png" alt="" />
            </div>
          </b-col>
          <b-col md="6" sm="6" xs="12">
            <div class="word">
              <div class="title">
                <img src="@i/rise/star.png" alt="" />
                <div>
                  <p class="title-heading">
                    抖音达人、直播间、爆款视频获客 单日可触达精准用户2000＋
                  </p>
                  <p class="title-des"></p>
                </div>
              </div>
              <div class="list-box">
                <div class="list">
                  <div class="list-title">
                    达人<span style="color: #0073f8">粉丝</span>捕手
                  </div>
                  <div class="list-subtitle">
                    关键词搜索，行业属性搜索，模糊搜索达人或明星，自动捕捉高价值用户。
                  </div>
                </div>
                <div class="list">
                  <div class="list-title">
                    意向客户<span style="color: #0073f8">筛选 批量</span>触达
                  </div>
                  <div class="list-subtitle">
                    关键词筛选如“多少钱”“哪里下单”等等高价值目标群体，
                    一键触达引导至自己的店铺或者添加微信好友。
                  </div>
                </div>
                <div class="list">
                  <div class="list-title">
                    <span style="color: #0073f8">用户</span>智能转化SOP
                  </div>
                  <div class="list-subtitle">
                    用户分层管理、行为跟踪、智能机器人及时触达、数据及时反馈促进成单。
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="hot">
      <b-container class="bv-example-row">
        <b-row align-v="center">
          <b-col md="6" sm="6" xs="12">
            <div class="word">
              <div class="title" v-show="false">
                <img src="@i/rise/star.png" alt="" />
                <div>
                  <p class="title-heading"></p>
                  <p class="title-des"></p>
                </div>
              </div>
              <div class="list-box" style="margin: 0">
                <div class="list">
                  <div class="list-title">
                    达人<span style="color: #0073f8">直播间</span>高价值用户捕手
                  </div>
                  <div class="list-subtitle">
                    搜索达人直播间，设置机器人潜伏即可捕捉直播间粉丝群体，自动筛选高价值用户。
                  </div>
                </div>
                <div class="list">
                  <div class="list-title">
                    目标客户群体实时触达提高转化<span style="color: #0073f8"
                      >实时触达</span
                    >提高转化
                  </div>
                  <div class="list-subtitle">
                    达人直播间粉丝触动关键词，平台智能跟进及时触达，提高转化。
                  </div>
                </div>
                <div class="list">
                  <div class="list-title">
                    <span style="color: #0073f8">目标群体</span>SOP流程化触达
                  </div>
                  <div class="list-subtitle">
                    热词分析、行为跟踪、精准触达，智能流程化引导目标群体
                    进入个人店铺或者添加个人微信。
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col md="6" sm="6" xs="12">
            <div class="mackbook">
              <img src="@i/rise/mackbook3.png" alt="" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="hot">
      <b-container class="bv-example-row">
        <b-row align-v="center">
          <b-col md="6" sm="6" xs="12">
            <div class="mackbook">
              <img src="@i/rise/mackbook4.png" alt="" />
            </div>
          </b-col>
          <b-col md="6" sm="6" xs="12">
            <div class="word">
              <div class="title" v-show="false">
                <img src="@i/rise/star.png" alt="" />
                <div>
                  <p class="title-heading">吸粉获客——AI外呼</p>
                  <p class="title-des">
                    站内配套AI外呼单日可触达用户10万+ 大大降低获客成本
                  </p>
                </div>
              </div>
              <div class="list-box">
                <div class="list">
                  <div class="list-title">
                    爆款<span style="color: #0073f8">视频</span>捕手 热词分析
                  </div>
                  <div class="list-subtitle">
                    搜索爆款视频，捕捉视频下方潜在客户，自动分析热词，制定触达话术实现精准引流。
                  </div>
                </div>
                <div class="list">
                  <div class="list-title">
                    <span style="color: #0073f8">自动触达</span>减少客户流失
                  </div>
                  <div class="list-subtitle">
                    自动化机器人及时回复，自动化标签，智能转化提升维护效率。
                  </div>
                </div>
                <div class="list">
                  <div class="list-title">
                    <span style="color: #0073f8">分层管理</span>提高转化率
                  </div>
                  <div class="list-subtitle">
                    智能化客户价值分层，行为分析根据客户意向度进行精准触达，提高转化率。
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="canal">
      <div class="title">企微&个微全域引流获客</div>
      <div class="subtitle">
        智晓慧微管家SaaS系统 助力企业快速搭建规模化私域流量池
      </div>
      <b-container class="bv-example-row canal-box">
        <b-row>
          <b-col md="3" sm="6" xs="12">
            <div class="card">
              <img src="@i/rise/user.png" alt="" />
              <div class="card-title">智能添加</div>
              <div class="card-des">
                批量导入通讯录表格，自定义时间段及话术，自动添加对方为好友，智能继承客户标签。
              </div>
            </div>
          </b-col>
          <b-col md="3" sm="6" xs="12">
            <div class="card">
              <img src="@i/rise/zhenshikexin.png" alt="" />
              <div class="card-title">借群获客</div>
              <div class="card-des">
                将机器人以KOL角色及用户角色潜入属性群，设定任务自动触发群内兴趣用户加好友。
              </div>
            </div>
          </b-col>
          <b-col md="3" sm="6" xs="12">
            <div class="card">
              <img src="@i/rise/shenfenrenzheng.png" alt="" />
              <div class="card-title">好友获客</div>
              <div class="card-des">
                通过价值活动激活客户主动分享传播，带来高价值目标客户。
              </div>
            </div>
          </b-col>
          <b-col md="3" sm="6" xs="12">
            <div class="card">
              <img src="@i/rise/erweima.png" alt="" />
              <div class="card-title">渠道活码</div>
              <div class="card-des">实时跟踪不同渠道客户来源，数字化管理。</div>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="bv-example-row canal-box">
        <b-row>
          <b-col md="3" sm="6" xs="12">
            <div class="card">
              <img src="@i/rise/renminbi.png" alt="" />
              <div class="card-title">红包获客</div>
              <div class="card-des">
                群内客户转介绍新用户即可获得红包激励，不符合进群要求拿不到激励，大大减低了获客成本。
              </div>
            </div>
          </b-col>
          <b-col md="3" sm="6" xs="12">
            <div class="card">
              <img src="@i/rise/maijiadianpu.png" alt="" />
              <div class="card-title">活动获客</div>
              <div class="card-des">
                制定抽奖玩法，激励客户邀请好友参与活动。
              </div>
            </div>
          </b-col>
          <b-col md="3" sm="6" xs="12">
            <div class="card">
              <img src="@i/rise/kuaisugaoxiao.png" alt="" />
              <div class="card-title">智能活码 加粉无上限</div>
              <div class="card-des">
                关联多个客户群，不限制进群人数，自动分流。
              </div>
            </div>
          </b-col>
          <b-col md="3" sm="6" xs="12">
            <div class="card">
              <img src="@i/rise/linghuokuozhan.png" alt="" />
              <div class="card-title">玩法获客</div>
              <div class="card-des">
                数十款营销玩法工具，裂变引流，智能化管理。
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <des-shout :hasLine="false">
      <template slot="title">
        <span style="color: black">沃享商城引流获客</span>
      </template>
      <template slot="des"> 多维度获客工具 拒绝硬广强化社交零售 </template>
    </des-shout>
    <des-list :data="data"></des-list>
    <div class="last">
      <des-shout :hasLine="false">
        <template slot="title">
          <span style="color: black">一站式跨平台引流</span>
        </template>
        <template slot="des"> 互联互通快速引流 打通客户留存链路 </template>
      </des-shout>
      <div style="width: 100%; text-align: center">
        <img src="@i/rise/22.png" alt="" />
      </div>
    </div>
    <Customer />
  </div>
</template>

<script>
import Des from "@/components/Des";
import Customer from "@/components/Customer";
import DesList from "@/components/DesList";
import DesShout from "@/components/DesShout";
export default {
  components: {
    Customer,
    des: Des,
    "des-list": DesList,
    "des-shout": DesShout,
  },
  data() {
    return {
      data: [
        {
          img: require("@i/rise/dicengjiagou.png"),
          title: "形式多样化",
          des: "图文，视频，直播，一键创建快速分享实现引流。",
        },
        {
          img: require("@i/rise/xingnengjisuan.png"),
          title: "智能海报",
          des: "自定义生产专属海报，扫码链接客户实现精准引流。",
        },
        {
          img: require("@i/rise/erweima.png"),
          title: "优惠券活码",
          des: "批量生成指定优惠券，关联指定会员。",
        },
        {
          img: require("@i/rise/liuzhuan.png"),
          title: "充值码",
          des: "分享锁客，突破限制，随时更新，智能切换。",
        },
        {
          img: require("@i/rise/saoma.png"),
          title: "群活码",
          des: "批量生成指定数量余额/积分，关联指定会员，用户扫码立即充值，同时锁定下线。",
        },
        {
          img: require("@i/rise/lianjie.png"),
          title: "视频号",
          des: "视频号链接商品，分享视频者获得分红。",
        },
      ],
    };
  },
};
</script>

<style>
.t-blue {
  color: #0073f8;
}
.rise .banner {
  position: relative;
}
.rise .banner img {
  width: 100%;
}
.rise .btn-g {
  position: absolute;
  top: 0;
  top: 80%;
  left: 13%;
}
.rise .btn-g button {
  background: #ffffff;
  color: #2f8df9;
  border-radius: 17px;
  border: none;
  font-weight: bold;
}

.rise .btn-g button:last-child {
  margin-left: 10px;
}
.rise .seven img {
  width: 100%;
}

.rise .hot {
  background: #f9fbff;
  padding: 50px 0;
}
.rise .hot .word .title {
  display: flex;
  align-items: center;
}

.rise .hot .word .title .title-heading {
  font-size: 25px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #0073f8;
}

.rise .hot .word .title .title-des {
  font-size: 10px;
  font-family: SourceHanSansCN;
  font-weight: 300;
  color: #323232;
  line-height: 17px;
}

.rise .list-box {
  line-height: 80px;
  margin-left: 100px;
}

.mackbook img {
  width: 100%;
}

.list-box .list {
}

.list-box .list .list-title {
  font-size: 25px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #323232;
}

.list-box .list .list-title::before {
  content: url(../../assets/rise/rectangle.png);
  margin-right: 15px;
}

.list-box .list .list-subtitle {
  font-size: 14px;
  font-family: SourceHanSansCN;
  font-weight: 300;
  color: #323232;
  line-height: 17px;
}

.rise .hot .word img {
}

.canal {
  background: url(../../assets/rise/bg1.png);
  background-size: cover;
  text-align: center;
  padding: 100px 0;
}

.canal .title {
  font-size: 25px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #ffffff;
}

.canal .subtitle {
  font-size: 14px;
  font-family: SourceHanSansCN;
  font-weight: 300;
  color: #ffffff;
  line-height: 17px;
}

.card {
  padding: 20px;
  line-height: 40px;
  margin-top: 40px;
  height: 250px;
}
.card {
}
.card img {
  width: 40px;
}
.card .card-title {
  text-align: left;
  margin-top: 20px;
}

.card .card-des {
  text-align: left;
  font-size: 14px;
}
.last {
  background-color: #f5f9ff;
  padding: 50px 0;
}
.last img {
  margin: 50px 0;
}
@media screen and (max-width: 400px) {
  .rise .btn-g {
    display: none;
  }

  .rise .list-box {
    line-height: 80px;
    margin-left: 20px;
  }

  .word {
    margin-top: 30px;
  }

  .mackbook {
    margin-top: 30px;
  }
}

@media screen and (max-width: 500px) {
  .last img {
    width: 100%;
  }
}
</style>